<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <app-language-translator [isAuthenticated]="isAuthenticated"></app-language-translator>
</ion-app>
